import type {
  GetRequestsListResponse,
  GetRequestsQuerystring,
} from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { requestListKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

type UseGetRequestListProps = Omit<
  GetRequestsQuerystring,
  "direction" | "limit" | "page" | "sortBy"
>;

export function useGetRequestList({
  category,
  fields,
  projectId,
}: UseGetRequestListProps) {
  return useQuery({
    enabled: projectId !== undefined,
    queryFn: () =>
      apiClient
        .url("/requests")
        .query({
          category: category,
          fields: fields,
          isDraft: false,
          projectId: projectId!,
        })
        .get()
        .json<GetRequestsListResponse>(),
    queryKey: requestListKeys.requestListByProjectId(projectId!, category),
  });
}
